import { FC, useMemo } from "react";

import { Category, CategoryFolder } from "~/api/model";
import { CategoryListItem } from "./CategoriesListItem";
import { FolderListItem } from "./FolderListItem";

type FolderListProps = {
  categories: Category[];
  folders: CategoryFolder[];
};

export const FolderList: FC<FolderListProps> = ({ categories, folders }) => {
  // Categories without folders (folderId is null or undefined)
  const standaloneCategories = useMemo(
    () => categories.filter((category) => !category.folderId),
    [categories]
  );

  return (
    <>
      {/* Folders with their categories */}
      {folders.map((folder) => (
        <FolderListItem key={folder.id} folder={folder} />
      ))}

      {/* Standalone categories - displayed directly without folder wrapper */}
      {standaloneCategories.map((category) => (
        <CategoryListItem key={category.id} category={category} />
      ))}
    </>
  );
};
